import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  AddReactionInput,
  addReactionMutation,
  addReactionMutation$data,
  ReactionContent,
} from './__generated__/addReactionMutation.graphql'
import type {addReactionMutation_ReactionGroups$data} from './__generated__/addReactionMutation_ReactionGroups.graphql'

export const updatedReaction_ReactionGroupsFragment = graphql`
  fragment addReactionMutation_ReactionGroups on Reactable {
    id
    reactionGroups {
      reactors(first: 5) {
        edges {
          node {
            ... on User {
              id
              login
              __typename
            }
            ... on Bot {
              id
              login
              __typename
            }
            ... on Organization {
              id
              login
              __typename
            }
            ... on Mannequin {
              id
              login
              __typename
            }
          }
        }
        totalCount
      }
      content
      viewerHasReacted
    }
  }
`

export function addReactionMutation({
  environment,
  input: {subject, content},
  onError,
  onCompleted,
  updatedReactionGroups,
  viewer,
}: {
  environment: Environment
  input: {
    subject: string
    content: ReactionContent
  }
  onError?: (error: Error) => void
  onCompleted?: (response: addReactionMutation$data) => void
  updatedReactionGroups: addReactionMutation_ReactionGroups$data
  viewer: {id: string; login: string}
}) {
  const inputHash: AddReactionInput = {
    subjectId: subject,
    content,
  }

  return commitMutation<addReactionMutation>(environment, {
    mutation: graphql`
      mutation addReactionMutation($input: AddReactionInput!) @raw_response_type {
        addReaction(input: $input) {
          subject {
            id
            ...ReactionViewerGroups
          }
          reaction {
            id
            content
            user {
              login
              id
            }
          }
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    optimisticResponse: {
      addReaction: {
        subject: {
          id: subject,
          reactionGroups: (updatedReactionGroups.reactionGroups || []).map(a => {
            return {
              content: a.content,
              viewerHasReacted: a.content === content ? true : a.viewerHasReacted,
              reactors: {
                edges: a.reactors.edges
                  ? a.reactors.edges.map(r => {
                      return {
                        node: {
                          id: r?.node.__typename === '%other' ? '' : r?.node.id || '',
                          login: r?.node.__typename === '%other' ? '' : r?.node.login,
                          __typename: 'User',
                          __isNode: 'User',
                        },
                      }
                    })
                  : [],
                totalCount:
                  a.content === content && !a.viewerHasReacted ? a.reactors.totalCount + 1 : a.reactors.totalCount,
              },
            }
          }),
          __isReactable: 'IssueComment',
          __typename: 'IssueComment',
        },
        reaction: {
          id: '',
          content,
          user: {
            login: viewer.login,
            id: viewer.id,
          },
        },
      },
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
